module.exports = __webpack_public_path__ + "static/media/how3.25b8048d.png";